import React, { useState, useEffect } from 'react';
import { getDevices } from '../../services/api';

function DeviceManager() {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadDevices();
  }, []);

  const loadDevices = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await getDevices();
      if (response.data.success) {
        setDevices(response.data.devices);
      } else {
        const errorMsg = typeof response.data.error === 'object' 
          ? response.data.error.message || 'Failed to load devices'
          : response.data.error || 'Failed to load devices';
        setError(errorMsg);
      }
    } catch (err) {
      const errorMsg = typeof err.response?.data?.error === 'object'
        ? err.response.data.error.message || 'Failed to load devices'
        : err.response?.data?.error || err.message || 'Failed to load devices';
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-inline">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-error">
        <span className="alert-icon">⚠️</span>
        <span>{error}</span>
      </div>
    );
  }

  return (
    <div>
      <p className="text-secondary" style={{ marginBottom: '20px' }}>
        Devices registered for development and testing. You can register up to 100 devices per platform.
      </p>

      {devices.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">📱</div>
          <p className="empty-state-title">No devices registered</p>
        </div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table className="data-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>UDID</th>
                <th>Platform</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {devices.map(device => (
                <tr key={device.id}>
                  <td>{device.attributes?.name || device.name || 'N/A'}</td>
                  <td className="mono">{device.attributes?.udid || device.udid || 'N/A'}</td>
                  <td>{device.attributes?.platform || device.platform || 'N/A'}</td>
                  <td>
                    <span className={`badge ${(device.attributes?.status || device.status) === 'ENABLED' ? 'badge-success' : 'badge-error'}`}>
                      {device.attributes?.status || device.status || 'UNKNOWN'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="alert alert-info" style={{ marginTop: '20px' }}>
        <span className="alert-icon">💡</span>
        <span>
          <strong>Tip:</strong> To register new devices, use the CLI tool by running <code>npm start</code>
        </span>
      </div>
    </div>
  );
}

export default DeviceManager;
